export const WIDGET_MEDIA_EMPTY_STATE = 'WIDGET_MEDIA_EMPTY_STATE';
